/*
 * Jira Ticket:
 * Editd Date: Wed, 18th Mar 2020, 11:58:36 am
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import React, { Fragment } from 'react';
import {
  Edit,
  FormDataConsumer,
  ReferenceArrayInput,
  ReferenceInput,
  required,
  SelectInput,
  SimpleForm,
  SelectArrayInput,
  useTranslate,
  useNotify,
  useRedirect,
  usePermissions,
  Title,
} from 'react-admin';
import { connect } from 'react-redux';
import { SaveDeleteToolbar } from 'Components';
import { AccessDenied } from 'Layout';
import { sideBySide } from 'styles';
import { isManager } from 'utils/roles';
import { booleanOptions, inviteRoleOptions } from 'utils/choices';

const SanitizedForm = ({ classes }) => {
  return (
    <Fragment>
      <FormDataConsumer>
        {({ formData, ...rest }) =>
          formData.organisation.id === formData.contractor.id ? (
            <SelectInput
              source="allowSubcontracting"
              choices={booleanOptions}
              className={classes.field}
              label={'resources.Subcontractor.fields.allowSubcontractor'}
            />
          ) : null
        }
      </FormDataConsumer>
      <SelectInput
        source="role"
        className={classes.field}
        choices={inviteRoleOptions()}
        defaultValue={'BUILDER'}
        label={'resources.Subcontractor.fields.maxRole'}
      />
    </Fragment>
  );
};

const SubcontractEdit = props => {
  const { dispatch, formValues, ...rest } = props;
  const { permissions } = usePermissions();
  const translate = useTranslate();
  const classes = sideBySide();
  const notify = useNotify();
  const redirect = useRedirect();
  if (!props.location.state) {
    redirect('/');
    notify('error.create.noOrgId', 'warning');
  }
  const { organisationId } = (props.location && props.location.state) || {};
  const divProps = { classes, ...rest };

  const subcontractRedirect = `/Organisation/${organisationId}/5`;

  return organisationId && isManager(permissions, organisationId) ? (
    <>
      <Title title={`resources.General.cmsTitle`} />
      <Edit
        undoable={false}
        title={`${formValues &&
          formValues[props.id] &&
          formValues[props.id].organisation.name +
            ' - ' +
            translate('resources.Subcontractor.fields.inviteSubcontractor')}`}
        {...rest}
      >
        <SimpleForm
          redirect={subcontractRedirect}
          toolbar={<SaveDeleteToolbar deleteRedirect={subcontractRedirect} />}
        >
          <ReferenceInput
            source="subcontractor.id"
            reference="Organisation"
            validate={required()}
            label={'resources.Subcontractor.fields.inviteOrg'}
          >
            <SelectInput optionText="name" disabled={true} />
          </ReferenceInput>
          <ReferenceInput
            source="organisation.id"
            reference="Organisation"
            validate={required()}
            label={'resources.Subcontractor.fields.toWorkFor'}
          >
            <SelectInput optionText="name" disabled={true} />
          </ReferenceInput>
          <FormDataConsumer>
            {({ formData, ...rest }) => (
              <ReferenceArrayInput
                {...rest}
                source="projectIds"
                reference="Project"
                perPage={1000}
                filter={{
                  principalOrganisationId: formData.organisation.id,
                  organisationId: formData.organisation.id,
                }}
                fullWidth
                validate={required()}
                label={'resources.Subcontractor.fields.toProjects'}
              >
                <SelectArrayInput optionText="name" />
              </ReferenceArrayInput>
            )}
          </FormDataConsumer>
          <SanitizedForm {...divProps} />
        </SimpleForm>
      </Edit>
    </>
  ) : (
    <AccessDenied />
  );
};

const mapStateToProps = state => ({
  formValues:
    state.admin.resources.Subcontract && state.admin.resources.Subcontract.data,
});

export default connect(mapStateToProps, {})(SubcontractEdit);
